import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../lib/api'

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState(false)

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    setLoading(true)
    try {
      await api.post('/fapi/auth/forgot-password', { email })
      setSuccess(true)
    } catch (err: any) {
      setError(err?.response?.data?.detail || 'Erreur lors de l\'envoi de l\'email')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="mx-auto flex w-full max-w-md flex-col gap-10 px-4 py-12 sm:py-16">
      <div className="relative overflow-hidden rounded-3xl border border-emerald-100/80 bg-white/90 shadow-2xl shadow-emerald-500/10 backdrop-blur dark:border-emerald-900/40 dark:bg-zinc-950/90 dark:shadow-none">
        <div aria-hidden className="absolute inset-0 -z-10 bg-gradient-to-br from-emerald-500/15 via-emerald-400/10 to-transparent" />
        <div className="relative px-8 py-12 sm:px-12">
          <div className="space-y-6">
            <div className="space-y-2 text-center">
              <span className="inline-flex items-center gap-2 rounded-full border border-emerald-200/70 bg-white/80 px-4 py-1 text-xs font-semibold uppercase tracking-[0.25em] text-emerald-600 shadow-sm dark:border-emerald-900/50 dark:bg-emerald-900/40 dark:text-emerald-300">
                Totemium
              </span>
              <h1 className="text-2xl font-bold tracking-tight text-zinc-900 dark:text-white sm:text-3xl">
                Mot de passe oublié ?
              </h1>
              <p className="text-sm text-zinc-600 dark:text-zinc-400">
                Entrez votre email pour recevoir un lien de réinitialisation.
              </p>
            </div>

            {success ? (
              <div className="space-y-4 text-center">
                <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-emerald-100 dark:bg-emerald-900/50">
                  <svg className="h-8 w-8 text-emerald-600 dark:text-emerald-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <div className="space-y-2">
                  <h3 className="text-lg font-semibold text-zinc-900 dark:text-white">Email envoyé !</h3>
                  <p className="text-sm text-zinc-600 dark:text-zinc-400">
                    Vérifiez votre boîte mail. Si l'adresse existe dans notre système, vous recevrez un lien de réinitialisation.
                  </p>
                  <p className="text-xs text-zinc-500 dark:text-zinc-500">
                    Le lien est valide pendant 1 heure.
                  </p>
                </div>
                <Link
                  to="/login"
                  className="inline-flex items-center gap-2 rounded-full border border-emerald-200/70 bg-white/80 px-4 py-2 text-sm font-medium text-emerald-700 shadow-sm transition hover:bg-emerald-50 dark:border-emerald-800 dark:bg-emerald-900/50 dark:text-emerald-200 dark:hover:bg-emerald-900/70"
                >
                  ← Retour à la connexion
                </Link>
              </div>
            ) : (
              <form onSubmit={submit} className="space-y-5">
                <div className="space-y-2">
                  <label className="text-sm font-medium text-zinc-600 dark:text-zinc-300" htmlFor="email">
                    Adresse email
                  </label>
                  <input
                    id="email"
                    className="w-full rounded-xl border border-emerald-100/80 bg-white/90 px-4 py-2 text-sm text-zinc-900 shadow-sm transition focus:border-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-200 dark:border-emerald-900/50 dark:bg-zinc-950/80 dark:text-zinc-100 dark:focus:border-emerald-500 dark:focus:ring-emerald-900/60"
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                    placeholder="votre@email.com"
                  />
                </div>
                {error && (
                  <div className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700 dark:border-red-900/60 dark:bg-red-950/40 dark:text-red-200">
                    {error}
                  </div>
                )}
                <button
                  disabled={loading}
                  className="w-full rounded-full bg-emerald-500 px-5 py-3 text-sm font-semibold text-white shadow-lg shadow-emerald-500/40 transition hover:bg-emerald-600 disabled:cursor-not-allowed disabled:opacity-70"
                >
                  {loading ? 'Envoi en cours…' : 'Envoyer le lien'}
                </button>
                <div className="text-center">
                  <Link
                    to="/login"
                    className="text-sm text-zinc-500 hover:underline dark:text-zinc-400"
                  >
                    ← Retour à la connexion
                  </Link>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
